import { useEffect } from "react";

const usePauseBrowserScroll = () => {
    useEffect(() => {
        if (location.hash) {
            setTimeout(function () {
                const scrollToTable = document.getElementById(
                    location.hash.replace("#", "")
                );
                if (scrollToTable) {
                    window.scrollTo({
                        top:
                            scrollToTable.getBoundingClientRect().top +
                            window.pageYOffset -
                            80,
                        behavior: "smooth",
                    });
                }
            }, 100);
        }
    }, []);
};
export default usePauseBrowserScroll;